import { RoomUpgrade } from 'models/RoomUpgrade';
import { Beverage } from 'models/Beverage';
import { Food } from 'models/Food';
import { Facilities } from 'models/Facilities';
import { UpsellServiceImage } from 'models/UpsellServiceImage';

import deluxeRoomImage from 'images/rooms_upgrade/deluxeRoom.jpg';
import studioRoomImage from 'images/rooms_upgrade/studioRoom.jpg';
import executiveRoomImage from 'images/rooms_upgrade/executiveRoom.jpg';

import EspressoEleganceImage from 'images/beverage/EspressoElegance.jpg';
import ChardonnayCharmImage from 'images/beverage/ChardonnayCharm.jpg';
import MerlotMajesticImage from 'images/beverage/merlotMajestic.jpg';

import croissantImage from 'images/breakfast/croissant.jpg';
import avocadoToastImage from 'images/breakfast/avocadoToast.jpg';
import bagelImage from 'images/breakfast/SmokedSalmonBagel.jpeg';

import swimmingPoolImage from 'images/facilities_booking/swimmingPool.jpg';
import gymRoomImage from 'images/facilities_booking/gymRoom.jpg';
import spaSuiteImage from 'images/facilities_booking/spaSuite.jpg';

import toiletriesImage from 'images/amenities/toiletries.jpg';
import bathTowelImage from 'images/amenities/bathTowel.jpg';
import pillowImage from 'images/amenities/pillow.jpg';

import roomUpgradeImage from 'images/upsell_Items/roomUpgrade.jpg';
import breakfastImage from 'images/upsell_Items/breakfast.jpg';
import lateCheckOutImage from 'images/upsell_Items/lateCheckOut.jpg';
import facilitiesImage from 'images/upsell_Items/facilities.jpg';
import eventsImage from 'images/upsell_Items/events.jpg';

import morningCallImage from 'images/digital_Concierge_Items/morningcall.png';
import amenitiesImage from 'images/digital_Concierge_Items/amenities.png';
import houseKeepingImage from 'images/digital_Concierge_Items/houseKeeping.png';
import roomControlImage from 'images/digital_Concierge_Items/roomControl.jpg';
import whatsappLiveImage from 'images/digital_Concierge_Items/whatsappLive.png';
import callImage from 'images/digital_Concierge_Items/call.png';

export const mockRooms: RoomUpgrade[] = [
    { id: 123, name: 'Deluxe Room', price: 258,
      details: 'Step into our Deluxe Room, where thoughtful design meets comfort across 30 sqm of space. Offering complimentary high-speed Wi-Fi, a separate standing shower, and a King-size Posturepedic mattress. Stay entertained with our Smart LED TV with Chromecast, and work or relax in an ergonomic armed chair. The ideal respite for your business and leisure activities during your stay.  ', 
      image: deluxeRoomImage },
    { id: 234, name: 'Studio Room', price: 278,
      details: "Indulge in the charm of our 30 sqm Studio Room, where you'll be greeted with panoramic views of the city skyline through expansive windows on selected high floors. Each room features a dedicated work area, complimentary high-speed Wi-Fi, Smart LED TV with Chromecast for your entertainment, and a King-size Posturepedic mattress for a comfortable stay. The spacious bathroom adds a touch of serenity with its scenic views, allowing guests to unwind while soaking in the bathtub or having a shower.", 
      image: studioRoomImage },
    { id: 345, name: 'Executive Room', price: 288,
      details: 'Experience contemporary elegance and warmth in our 34 sqm Executive Room, making you feel at home. Each room is equipped with a work area featuring an ergonomic armed chair for your utmost comfort. Stay seamlessly connected with complimentary high-speed Wi-Fi and enjoy a wide selection of entertainment on Smart LED TV with Chromecast. To add a touch of luxury to your experience, a separate bathtub and a standing rain shower is offered. ', 
      image: executiveRoomImage },
];

export const mockBeverage : Beverage[] = [    
    { id: 110, name: 'Espresso Elegance', price: 4, quantity: 0, 
    details: 'A single shot of rich and intense espresso, perfect for coffee enthusiasts.', 
    image: EspressoEleganceImage },
    { id: 120, name: 'Chardonnay Charm', price: 28, quantity: 0,
    details: "A crisp and refreshing white wine featuring flavors of green apple and citrus.", 
    image: ChardonnayCharmImage },
    { id: 130, name: 'Merlot Majesty', price: 25, quantity: 0,
    details: 'A smooth and velvety red wine with notes of dark berries and a hint of oak. ', 
    image: MerlotMajesticImage },    
];

export const mockFood : Food[] = [    
    { id: 210, name: 'Classic Croissant', price: 8.5, quantity: 0, 
    details: 'Freshly baked buttery croissant served with jam and butter.', 
    image: croissantImage },
    { id: 220, name: 'Avocado Toast', price: 12, quantity: 0,
    details: "Sliced avocado on whole-grain toast, topped with cherry tomatoes, feta cheese, and a drizzle of olive oil.", 
    image: avocadoToastImage },
    { id: 330, name: 'Smoked Salmon Bagel Sandwich', price: 15.5, quantity: 0,
    details: 'Bagel with cream cheese, smoked salmon, capers, red onion, and fresh dill. ', 
    image: bagelImage },  
];

export const mockRoomService : Food[] = [
  { id: 111, name: 'Classic Croissant', price: 8.5, quantity: 0, 
    details: 'Freshly baked buttery croissant served with jam and butter.', 
    image: croissantImage },
    { id: 222, name: 'Avocado Toast', price: 12, quantity: 0,
    details: "Sliced avocado on whole-grain toast, topped with cherry tomatoes, feta cheese, and a drizzle of olive oil.", 
    image: avocadoToastImage },
    { id: 333, name: 'Smoked Salmon Bagel Sandwich', price: 15.5, quantity: 0,
    details: 'Bagel with cream cheese, smoked salmon, capers, red onion, and fresh dill. ', 
    image: bagelImage },  
    { id: 444, name: 'Espresso Elegance', price: 4, quantity: 0, 
    details: 'A single shot of rich and intense espresso, perfect for coffee enthusiasts.', 
    image: EspressoEleganceImage },
    { id: 555, name: 'Chardonnay Charm', price: 28, quantity: 0,
    details: "A crisp and refreshing white wine featuring flavors of green apple and citrus.", 
    image: ChardonnayCharmImage },
    { id: 666, name: 'Merlot Majesty', price: 25, quantity: 0,
    details: 'A smooth and velvety red wine with notes of dark berries and a hint of oak. ', 
    image: MerlotMajesticImage }, 
]

export const mockFacilities : Facilities[] = [    
    { id: 101, name: 'Swimming Pool', price: 25, hourBooking: 0,
    details: 'Private pools for a more luxurious and relaxing stay.', 
    image: swimmingPoolImage },
    { id: 201, name: 'Gym Room', price: 15, hourBooking: 0,
    details: "Access to premium fitness equipment and services.", 
    image: gymRoomImage },
    { id: 301, name: 'Spa Facilities', price: 50, hourBooking: 0,
    details: 'Access to spa facilities, including saunas, steam rooms, and relaxation areas. ', 
    image: spaSuiteImage },  
];

export const mockAmenities: Food[] = [
    { id: 401, name: 'Toiletries', price: 0, details: "", quantity: 0,  
      image: toiletriesImage },
    { id: 501, name: 'Bath Towel', price: 0, details: "", quantity: 0,
      image: bathTowelImage },
    { id: 601, name: 'Pillow', price: 0, details: "", quantity: 0,
      image: pillowImage },
];

export const upsellImages: UpsellServiceImage[] = [
    { imageUrl: roomUpgradeImage, title: "Room Upgrade" },
    { imageUrl: breakfastImage, title: "Room Service" },
    { imageUrl: lateCheckOutImage, title: "Late Check-Out" },
    { imageUrl: facilitiesImage, title: "Facilities Booking" },
    { imageUrl: eventsImage, title: "Events" },
];

export const serviceImages: UpsellServiceImage[] = [
    { imageUrl: morningCallImage, title: "Morning Call" },
    { imageUrl: amenitiesImage, title: "Amenities" },
    { imageUrl: houseKeepingImage, title: "Housekeeping" },
    { imageUrl: roomControlImage, title: "Room Control" },
    { imageUrl: whatsappLiveImage, title: "WhatsApp" },
    { imageUrl: callImage, title: "Call" },
];

export const mockUpsellRoom: any [] = [
    mockRooms[0],
    mockRooms[1],
];

export const mockUpsellBreakfast: any [] = [
  mockFood[0],
  mockFood[1],
];

export const mockUpsellBeverage: any [] = [
  mockBeverage[0],
  mockBeverage[1],
];

export const mockUpsellFacility: any [] = [
  mockFacilities[0],
  mockFacilities[1],
];

export const mockUpsellData: any [] = [
  mockRooms[0],
  mockRooms[1],
  mockFood[1],
  mockBeverage[0],
  mockFacilities[0],
  mockFacilities[2],
];